import './DeepDiveDetailPanel.scss';
import '../../../../Admin/BuyerMarketplace/OpportunityDetails/LoiSubmissionPackage/LoiAndTermsForm/TermsFormDisplay.scss';
import React from 'react';
import { LoiComparisonFormDto } from '../../../../../slices/marketplace/loi-comparison/models/loi-comparison-form.model';
import { DEEP_DIVE_REGISTRY } from './detail-config';
import { TermsFormDetailBlock } from '../../../../Admin/BuyerMarketplace/OpportunityDetails/LoiSubmissionPackage/LoiAndTermsForm/TermsFormDetailBlock';
import { formatCurrency } from '../LoiComparisonRows';

const EMPTY_CELL = '—';

interface OtherDetailBlockProps {
    buyer: LoiComparisonFormDto;
}

const OtherDetailBlock = ({ buyer }: OtherDetailBlockProps) => {
    const summary = buyer.form?.termForm?.purchasePriceSummary;
    const fairValue = summary?.otherFairValue;
    const explanation = summary?.otherFairValueExplanation;
    const hasData = fairValue != null || (explanation != null && explanation.trim().length > 0);

    if (!hasData) {
        return <div className="deep-dive-no-data">No data provided</div>;
    }

    return (
        <div className="deep-dive-detail-panel__other">
            <div>
                <strong>Fair Value:</strong>{' '}
                {fairValue != null ? formatCurrency(fairValue) : EMPTY_CELL}
            </div>
            {explanation != null && explanation.trim().length > 0 && (
                <div>{explanation}</div>
            )}
        </div>
    );
};

export interface DeepDiveDetailPanelProps {
    rowLabel: string;
    buyer: LoiComparisonFormDto;
}

export const DeepDiveDetailPanel = ({
    rowLabel,
    buyer,
}: DeepDiveDetailPanelProps) => {
    const builder = DEEP_DIVE_REGISTRY[rowLabel];
    const summary = buyer.form?.termForm?.purchasePriceSummary;
    const isOther = rowLabel === 'Other';

    const viewProps = builder ? builder(summary) : null;
    const hasFaceValue = viewProps != null && Number(viewProps.displayTotal) > 0;

    return (
        <div className="deep-dive-detail-panel">
            {isOther ? (
                <OtherDetailBlock buyer={buyer} />
            ) : hasFaceValue && viewProps ? (
                <div className="terms-form-display">
                    <div className="terms-form-section-body">
                        <TermsFormDetailBlock
                            title={viewProps.title}
                            columns={viewProps.columns}
                            rows={viewProps.rows}
                            readOnly={true}
                            onRowsChange={() => {}}
                            displayTotal={viewProps.displayTotal}
                            showTotalRow={viewProps.showTotalRow}
                            singleRow={viewProps.singleRow}
                            showPaymentNumber={viewProps.showPaymentNumber}
                            paymentNumberHeader={viewProps.paymentNumberHeader}
                        />
                    </div>
                </div>
            ) : (
                <div className="deep-dive-no-data">No data provided</div>
            )}
        </div>
    );
};
